
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./graphql-scala-2-preparing-first-query.json") })
        }
      }, "path---graphql-scala-2-preparing-first-query");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---graphql-scala-2-preparing-first-query!./.cache/json/graphql-scala-2-preparing-first-query.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---graphql-scala-2-preparing-first-query!./.cache/json/graphql-scala-2-preparing-first-query.json
// module chunks = 154